export const userHelperMixin = {
  computed: {
    userProfileMix () {
      return this.$store.getters.getUserProfile
    },
    userMaxBotsMix () {
      if (this.userProfileMix?.isAutotradingUser) return process.env.VUE_APP_DEFAULT_MAX_BOTS_AT_USERS

      if (this.userIsSignumTelegramAdminMix) return process.env.VUE_APP_DEFAULT_MAX_BOTS_AT_USERS

      return process.env.VUE_APP_DEFAULT_MAX_BOTS
    },
    userIsSignumTelegramAdminMix () {
      // TODO: Users we've given 50 Bots because we don't yet have a subscription for that. This will disappear and they will need tp pay for it once we do have.
      // 17 = signum-demo@autotrading.vip (for testing purposes)
      // 4961 = sebastian.herzog.1983@gmail.com | Gave him 50 Bots because we have no Plan for that yet
      // 32 = cjsgrilljosh@gmail.com (Josh Admin) | Removed him
      // 3371 = flumperdump@hotmail.com (Sweman Admin)
      // 2764 = rohani_t@yahoo.com (Traneh Admin)
      // 1980 = signum-account-2.immovable569@passinbox.com (Grum Admin)
      // 551 = signum.only195@passinbox.com (Grum Admin)
      // 2584 = signum-account-3.dill781@passinbox.com (Grum Admin)
      // 5210 = signum-account-4.spectrum178@passinbox.com (Grum Admin)
      // 2669 = cameronhutcheon4@gmail.com (Spanky Admin) | Removed him
      // 2442 = dumitrascu17@gmail.com (skyllet - Romanian guy)
      if ([17, 4961, 3371, 2764, 1980, 551, 2584, 5210, 2442].includes(this.userProfileMix?.id)) return true
      return false
    },
    userIsAutoTradingOrTelegramAdminMix () {
      if (this.userProfileMix?.isAutotradingUser || this.userIsSignumTelegramAdminMix) return true
      return false
    },
    userIsAutoTradingMix () {
      if (this.userProfileMix?.isAutotradingUser) return true
      return false
    },
    userHasAccessToStrategiesMix() {
      if (this.userProfileMix?.hasStrategyAccess) {
        return true
      }
      return false
    },
    userHasAccessToAtxStrategiesMix() {
      if (this.userProfileMix?.hasStrategyAccess && this.userProfileMix.isAutotradingUser) {
        return true
      }
      return false
    }
  },
  methods: {
  },
}